import { type InjectionKey, type Ref } from "vue";

export const isModalVisibleInjectionKey = Symbol() as InjectionKey<Ref<boolean>>;
